import { formatLocale } from 'd3';

export default formatLocale({
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['€', ''],
});
